<template>
  <div class="out-entrepot-wrapper">
    <!-- 导出操作 -->
    <div class="filter-actions" v-if="formData.status==1">
      <span class="action-label">公司抬头</span>
      <el-select v-model="titleCompany" placeholder="请选择公司抬头" size="small">
        <el-option v-for="item in titleCompanyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="exportOutEntrepot">导出 Excel</el-button>
    </div>

    <div class="out-entrepot-paper">
    <!-- 顶部信息行 -->
    <table class="info-table table-layout">
      <tbody>
        <tr>
          <td class="info-cell">
            <span class="info-label">客户名称：</span>
            <span class="info-text">{{ formData.customerName }}</span>
          </td>
          <td class="info-cell">
            <span class="info-label">开单日期：</span>
            <span class="info-text">{{ parseTime(formData.createTime, '{y}/{m}/{d}') }}</span>
          </td>
          <td class="info-cell">
            <span class="info-label">单号：</span>
            <span class="info-text">{{ formData.number }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 出库明细表格 -->
    <table class="item-table table-layout">
      <thead>
        <tr>
          <th width="60">序号</th>
          <th>品名</th>
          <th width="80">数量</th>
          <th width="60">单位</th>
          <th width="90">价格</th>
          <th width="90">货款</th>
          <th>备注</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in formData.contentList" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.categoryName }}</td>
          <td>{{ item.quantity }}</td>
          <td>{{ item.units }}</td>
          <td>{{ item.unitPrice }}</td>
          <td>{{ item.paymentGoods }}</td>
          <td class="remark-cell" v-html="replaceNewlines(item.remark)"></td>
        </tr>
        <!-- 合计行 -->
        <tr class="total-row">
          <td colspan="2">合计</td>
          <td>{{ formData.total }}</td>
          <td colspan="4" class="remark-cell" v-html="replaceNewlines(formData.noticeRemark)"></td>
        </tr>
        <!-- 备注行 -->
        <tr class="bottom-remark-row" v-if="formData.remark">
          <td>备注</td>
          <td colspan="6" class="remark-cell" v-html="replaceNewlines(formData.remark)"></td>
        </tr>
      </tbody>
    </table>

    <!-- 签名栏 -->
    <table class="sign-table table-layout">
      <tbody>
        <tr>
          <td class="sign-label">制单：</td>
          <td class="sign-value"><span class="sign-line">{{ formData.maker || '' }}</span></td>
          <td class="sign-label">财务：</td>
          <td class="sign-value"><span class="sign-line">{{ formData.finance || '' }}</span></td>
          <td class="sign-label">仓库：</td>
          <td class="sign-value"><span class="sign-line">{{ formData.warehouse || '' }}</span></td>
          <td class="sign-label">客户签名：</td>
          <td class="sign-value"><span class="sign-line">{{ formData.customerSign || '' }}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
  </div>
</template>

<script>
  import { outEntrepotDetailById } from "@/api/api.js";
  export default {
    name: "OutEntrepot",
    props: {
      outEntrepotId: {
        type: [Number, String]
      }
    },
    data() {
      return {
        formData: {},
        titleCompanyList: [
          { value: '1', label: '桔子智联' },
          { value: '2', label: '中为捷讯' }
        ],
        titleCompany: '1',
      };
    },
    methods: {
      initData() {
        outEntrepotDetailById({ id: this.outEntrepotId }).then(res => {
          this.formData = res.data.data || {};
        });
      },
      exportOutEntrepot() {
        let params = {id: this.formData.id, titleCompany: this.titleCompany};
        this.download('/outEntrepot/exportExcel', params, 'outEntrepot_' + this.formData.number + '.xlsx');
      },
      replaceNewlines(text) {
        if (text) {
          return text.replace(/\n/g, "<br>");
        }
        return "";
      },
    },
    watch: {
      outEntrepotId() {
        this.initData();
      }
    },
    mounted() {
      this.initData();
    },
  };
</script>

<style scoped lang="less">
  @text-primary: #303133;
  @text-regular: #606266;
  @border-color: #DCDFE6;
  @bg-header: #F5F7FA;

  .out-entrepot-wrapper {
    /* 导出操作栏 + 纸张的容器 */
  }

  .filter-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    padding: 10px 16px;
    background: #FAFBFC;
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    .action-label {
      font-size: 13px;
      color: @text-regular;
      font-weight: 500;
    }
  }

  .out-entrepot-paper {
    background: #fff;
    color: @text-primary;
    font-size: 14px;
    line-height: 1.6;
  }

  .table-layout {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    td, th {
      border: 1px solid @border-color;
      padding: 10px 12px;
      vertical-align: middle;
      text-align: center;
    }
  }

  /* ================= 顶部信息行 ================= */
  .info-table {
    margin-bottom: 12px;
    border: none;
    td, th {
      border: none;
      padding: 6px 0;
      text-align: left;
    }
    .info-cell {
      width: 33.33%;
    }
    .info-label {
      font-weight: bold;
      color: @text-primary;
    }
    .info-text {
      color: @text-regular;
      font-size: 16px;
      font-weight: 500;
    }
  }

  /* ================= 出库明细表格 ================= */
  .item-table {
    margin-bottom: 0;
    thead th {
      background: @bg-header;
      color: @text-primary;
      font-weight: 600;
      text-align: center;
    }
    tbody td {
      color: @text-primary;
    }
    .total-row {
      td {
        background: @bg-header;
        font-weight: 500;
      }
    }
    .bottom-remark-row {
      td {
        background: @bg-header;
        font-weight: 500;
        text-align: center;
      }
      td:last-child {
        text-align: left !important;
        background: #fff;
        font-weight: normal;
      }
    }
  }

  .remark-cell {
    text-align: left !important;
    word-break: break-word;
    line-height: 1.7;
    white-space: pre-line;
  }

  /* ================= 签名栏 ================= */
  .sign-table {
    margin-top: 24px;
    border: none;
    td {
      border: none;
      padding: 8px 0;
      vertical-align: bottom;
    }
    .sign-label {
      width: 80px;
      text-align: left;
      font-weight: bold;
      color: @text-primary;
      white-space: nowrap;
    }
    .sign-value {
      text-align: left;
    }
    .sign-line {
      display: inline-block;
      min-width: 120px;
      min-height: 24px;
      border-bottom: 1px dashed @border-color;
      padding: 0 8px;
      color: @text-regular;
    }
  }
</style>
